import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store';
import {
    fetchEmailTracking,
    clearEmailTracking,
} from '../features/email-tracking/email-tracking.slice';
import { EmailTrackingKind } from '../features/email-tracking/email-tracking.types';

/**
 * Custom hook wrapping the emailTracking slice — loads the timeline for an
 * invoice, customer offer or customer contract and exposes state + actions to
 * the modal. Mirrors the per-feature hook convention (useInvoice,
 * useInvoiceSearch).
 */
export const useEmailTracking = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { details, loading, error } = useSelector((state: RootState) => state.emailTracking);

    const loadTracking = (id: number, kind: EmailTrackingKind = 'invoice') =>
        dispatch(fetchEmailTracking({ id, kind }));
    const clear = () => dispatch(clearEmailTracking());

    return { details, loading, error, loadTracking, clear };
};
